'use client';

import { usePathname } from "next/navigation";
import { useState, useRef } from "react";
import DropdownOverlay from "../../shared/DropdownOverlay";
import ClientSearchPageWrapper from "../../../app/(protected)/project/[projectCode]/search/ClientSearchPageWrapper";

interface SearchIconProps {
  userEmail?: string;
}

export default function SearchIcon({ userEmail }: SearchIconProps) {
  const [isOverlayOpen, setIsOverlayOpen] = useState(false);
  const buttonRef = useRef<HTMLButtonElement>(null);
  const pathname = usePathname();
  const projectCode = pathname.match(/\/project\/([^/]+)/)?.[1];


  if (!userEmail?.endsWith("@workltd.co.uk") || !projectCode) {
    return null;
  }

  return (
    <>
      <button 
        ref={buttonRef}
        onClick={() => setIsOverlayOpen(!isOverlayOpen)}
        className="hover:text-gray-600 dark:hover:text-gray-300"
      >
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-6 h-6">
          <path strokeLinecap="round" strokeLinejoin="round" d="M21 21l-5.197-5.197m0 0A7.5 7.5 0 1 0 5.196 5.196a7.5 7.5 0 0 0 10.607 10.607Z" />
        </svg>
      </button>
      
      <DropdownOverlay
        isOpen={isOverlayOpen}
        onClose={() => setIsOverlayOpen(false)}
        triggerRef={buttonRef}
      >
        <ClientSearchPageWrapper 
          projectCode={projectCode} 
          onNavigateToResource={() => setIsOverlayOpen(false)}
        />
      </DropdownOverlay>
    </>
  );
} 